import { BaseRestDataProvider } from './BaseRestDataProvider';
import { Ledger } from '../models/Ledger';

export class LedgerRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/ledger');
  }

  getAll(): Promise<Ledger[]> {
        return this.get<Ledger[]>(``);
  }

  getById(id: string): Promise<Ledger> {
        return this.get<Ledger>(`/${id}`);
  }

  add(rate: Ledger): Promise<void> {
    return this.post<void>(``, rate);
  }

  update(id: string, rate: Ledger): Promise<void> {
    return this.put<void>(`/${id}`, rate);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { Ledger };
